import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer({ isForLogin = false }) {
    const credit = (
        <span className='text-gray-500'>© {moment(Date.now()).format("YYYY")} <a className='font-medium text-brand-600 hover:text-brand-700' href='https://cubicleeight.com' target='_blank' rel="noreferrer">Cubicle Eight</a>. All rights reserved.</span>
    )
    return (
        isForLogin ?
            <span className="text-xs">{credit}</span>
            :
            <footer className="border-t border-gray-100 bg-white py-4 px-4">
                <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm">
                    <Link className="text-gray-600 hover:text-brand-600" to="/">Home</Link>
                    <Link className="text-gray-600 hover:text-brand-600" to="/about">About</Link>
                    <Link className="text-gray-600 hover:text-brand-600" to="/contact">Contact</Link>
                    <Link className="text-gray-600 hover:text-brand-600" to="/terms">Terms</Link>
                    <Link className="text-gray-600 hover:text-brand-600" to="/privacy">Privacy</Link>
                    <span className='hidden sm:block text-gray-300'>|</span>
                    {credit}
                </div>
            </footer>
    )
}
